var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.115,
    height: 133.314,
    viewBox: "0 0 135.115 133.314",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.601,
    height: 31.487,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.039,
    height: 11.821,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.894,285.719l.734,11.2s3.6,6.414,7.207,4.506c1.61-.849,1.886-1.921,1.7-2.852a1.847,1.847,0,0,1,1.4-2.138c1.309-.321,2.552-1.247,2.207-3.688-.455-3.2-3.295-4.154-5.135-4.438a1.651,1.651,0,0,1-1.381-1.453c-.178-1.437-1.982-1.53-2.224-2.262-.3-.912-1.928-1.706-1.928-1.706Z",
    transform: "translate(-713.894 -282.885)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -28.885,
    y1: 8.902,
    x2: -28.883,
    y2: 8.902,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9eaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101011"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M697.213,281.972c2.709,8.478,13.245,17.27,13.245,17.27,1.287-.543,2.955-5.3,2.955-5.3-8.559-2.2-15.766-13.592-15.766-13.592Z",
    transform: "translate(-697.213 -280.354)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -24.854,
    y1: 9.659,
    x2: -24.852,
    y2: 9.659,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#505355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141212"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.31,330.544s1.2,12.187,1.421,17.062a3.847,3.847,0,0,1-.565,2.169l-2.1,3.4,5.315-3.144.1-.648-.872-1.2,1.141-13.652a4.211,4.211,0,0,0-.477-2.318l-1.1-2.066-2.515-1.726Z",
    transform: "translate(-713.07 -328.425)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -80.934,
    y1: 6.87,
    x2: -80.914,
    y2: 6.87,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M721.545,329.43s7.05,13.37,8.174,16.424a29.579,29.579,0,0,1,1.529,5.84c.023.377.494.734,1.782.734a1.243,1.243,0,0,0,1.153-.524.756.756,0,0,0,.03-.734c-.407-.824-1.7-3.458-2.18-4.656-.574-1.428-1.8-7.9-2.477-10.151a11.938,11.938,0,0,0-4.379-6.941,3.239,3.239,0,0,0-1.971-.877,2.094,2.094,0,0,0-1.657.879",
    transform: "translate(-721.545 -328.545)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -45.67,
    y1: 8.765,
    x2: -45.664,
    y2: 8.765,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.275,287.711l-1.226.543a.828.828,0,0,0-.486.868l.636,4.6a.678.678,0,0,0,.078.25,3.939,3.939,0,0,0,2.632,1.312c.593.113,1.125.21.984-.375l-1.478-6.643c-.015-.047-.03-.094-.049-.14a.829.829,0,0,0-.756-.489.8.8,0,0,0-.334.072",
    transform: "translate(-712.555 -287.64)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -107.488,
    y1: 24.006,
    x2: -107.452,
    y2: 24.006,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.776,299.484a.577.577,0,0,0,.127.71c5.377,4.71,4.065,8.876,3.367,10.292a.379.379,0,0,1-.055.085.485.485,0,0,1-.681.083.979.979,0,0,0-1.279.057l-1.281,2.7a.475.475,0,0,0,.03.458.079.079,0,0,0,.018.028.347.347,0,0,0,.487.064h0a11.217,11.217,0,0,1,1.858-1.258,2.307,2.307,0,0,0,1.014-.588c9-7.755-1.317-15.139-1.317-15.139a5.226,5.226,0,0,0-2.291,2.515",
    transform: "translate(-717.706 -296.974)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -60.324,
    y1: 17.422,
    x2: -60.313,
    y2: 17.422,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.693,282.476a6.557,6.557,0,0,0-2.249,3.773c-.675,2.712.419,3.688,1.548,3.626a5.219,5.219,0,0,0,4.175-2.353c1.237-1.7-.771-5.287-2.673-5.287a1.478,1.478,0,0,0-.8.236",
    transform: "translate(-710.237 -282.235)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -55.737,
    y1: 19.452,
    x2: -55.727,
    y2: 19.452,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M711.58,280.8c-1.747,1.343-.169,3.124-.169,3.124l.652-.681c3.228-.593,2.652,3.294,2.652,3.294l.222.06s.551-.893.979-.329-.086,1.886-.086,1.886.849,1.3,1.97-.217.639-3.235-.7-5.685a3.84,3.84,0,0,0-3.326-2.226,3.581,3.581,0,0,0-2.191.779",
    transform: "translate(-710.757 -280.029)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -49.087,
    y1: 18.699,
    x2: -49.079,
    y2: 18.699,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M714.956,286.627l.378.882c.56-.44,1.949-1.739.928-2.306a.741.741,0,0,0-.35-.1c-.734,0-.956,1.53-.956,1.53",
    transform: "translate(-714.956 -285.099)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -202.326,
    y1: 49.557,
    x2: -202.208,
    y2: 49.557,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M693.634,277.192l1.579,1.067a6.444,6.444,0,0,0-.433,1.654,1.852,1.852,0,0,0,.468,1.293,16.065,16.065,0,0,0,1.115,1.175,1.827,1.827,0,0,0,1.516.512c-.021.236.852.4,1.131-.609a8.712,8.712,0,0,0-.546-2.638,35.085,35.085,0,0,0-4.942-3.354.646.646,0,0,0,.111.9",
    transform: "translate(-693.39 -276.293)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -70.608,
    y1: 25.041,
    x2: -70.592,
    y2: 25.041,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M695.777,278.8a.574.574,0,0,0-.241.406.778.778,0,0,0,.275.567A12.9,12.9,0,0,1,696.918,282l.241-.1a13.5,13.5,0,0,0-1.153-2.306.559.559,0,0,1-.2-.373.242.242,0,0,1,.081-.162l1.279.683.564.886.22-.14-.6-.943-1.5-.8Z",
    transform: "translate(-695.536 -278.736)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: -335.981,
    y1: 78.107,
    x2: -335.663,
    y2: 78.107,
    xlinkHref: "#f"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-841.85 -162.764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M668.816,237.826a62.977,62.977,0,1,1-62.983,62.983,62.977,62.977,0,0,1,62.983-62.983h0",
    transform: "translate(236.38 -68.072)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.833,364.167a63.347,63.347,0,1,1,63.348-63.348,63.347,63.347,0,0,1-63.348,63.348m0-125.955a62.608,62.608,0,1,0,62.608,62.608h0a62.68,62.68,0,0,0-62.608-62.608",
    transform: "translate(236.363 -68.089)",
    fill: "#d9dadc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.58,242.744a57.82,57.82,0,1,1-57.82,57.822,57.82,57.82,0,0,1,57.82-57.822h0",
    transform: "translate(236.616 -67.836)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.518,309.191s.372-15.615-6.817-19.793-20.864-6.789-21.379-29.207c-.3-13.123-.629-18.864-.838-21.363a1.476,1.476,0,0,1,1.337-1.6h0a1.409,1.409,0,0,1,.4.019c6.812,1.284,28.93,6.562,33.573,21.662,5.5,17.907-6.282,50.284-6.282,50.284",
    transform: "translate(236.89 -68.102)",
    fill: "#6e7073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.194,243.2c7.477,6.667,16.12,18.465,20.725,30.263a55.414,55.414,0,0,1,3.074,13.429,61.906,61.906,0,0,1-.476,16.889.5.5,0,0,1-.584.4h0a.505.505,0,0,1-.4-.574,68.479,68.479,0,0,0-1.585-24.661c-2.725-10.1-8.786-19.891-15.061-28.191l-.647-.818c-4.863-6.242-5.888-6.288-5.43-6.724a.283.283,0,0,1,.384-.005",
    transform: "translate(237.189 -67.817)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.555,334.339c1,.414-9.979-11.713-14.446-31.583-2.1-9.361-2.881-21.214-8.561-25.431-4.728-3.514-19.831-.137-24.767,1.1a.749.749,0,0,0-.266,1.331c2.523,1.856,7.948,6.271,9.589,10.962,2.161,6.183,8.408,9.811,13.833,10.558s8.481,1.6,11.643,10.01,10.125,21.879,12.971,23.055",
    transform: "translate(236.686 -66.252)",
    fill: "#7a7e81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.627,280.409c6.386-.14,13.414,2.329,17.228,7.555l.36.5a122.546,122.546,0,0,1,8.513,16.6.17.17,0,0,1-.093.221h0a.176.176,0,0,1-.22-.09c-1.92-3.952-4.63-8.947-6.773-12.675-2.306-4.068-3.908-6.822-8.723-9.249a25.909,25.909,0,0,0-10.294-2.587.138.138,0,0,1,0-.277Z",
    transform: "translate(237.034 -66.029)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.81,280.055c-.334-15.419-.879-30.163-1.757-40.242-.271-3.09-2.384-5.523-5.03-5.794-11.407-1.159-49.948-3.837-64.7-2.494-2.661.241-4.716,2.83-4.733,5.95-.014,2.64-.036,6.162-.055,10.341-.127,26.128-.252,77.871.592,97.986a4.389,4.389,0,0,0,3.941,4.482c7.594.176,29.867.456,48.051.176a57.988,57.988,0,0,0,24.179-29.513c-.047-12.179-.179-26.813-.484-40.892",
    transform: "translate(238.232 -68.393)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.155,242.951c-.333,15.422-1.338,66.728-.489,85.681.125,2.769,2.029,4.982,4.394,5.109,9.754.524,43.017,1.491,57.29-.062,2.57-.28,4.55-2.74,4.646-5.764.489-15.734,1.851-63.517,1.03-82.258-.132-2.991-2.148-5.4-4.7-5.632-10.556-.949-45.92-3.052-58.058-2.1a4.865,4.865,0,0,0-4.115,5.019",
    transform: "translate(238.419 -68.079)",
    fill: "#9a9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.08,234.45h0a1.039,1.039,0,0,0,.906,1.087c2.471.114,9.432.437,12.546.6a1.048,1.048,0,0,0,.991-1.1v-.008a1.076,1.076,0,0,0-.034-.21l-.021-.118a1.012,1.012,0,0,0-.852-.877,103.008,103.008,0,0,0-12.65-.486,1.034,1.034,0,0,0-.884,1.111",
    transform: "translate(239.606 -68.289)",
    fill: "#080909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.935,346.706l2.707-45.52a4.926,4.926,0,0,0-4.887-4.964h0c-.175,0-.35.008-.524.025l-72.881,3.716a5.123,5.123,0,0,0-4.391,2.787,57.837,57.837,0,0,0,34.809,48.392h40.043a4.954,4.954,0,0,0,5.122-4.436",
    transform: "translate(236.625 -65.271)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(848.747 230.965)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.004 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.309,325.917l38.356-29.226a5.494,5.494,0,0,0-2.487-.447L615.3,299.959a5.346,5.346,0,0,0-3.232,1.271l28.715,24.425a9.562,9.562,0,0,0,11.528.261",
    transform: "translate(-612.065 -296.235)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(867.25 247.378)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M646.132,323.718a8.484,8.484,0,0,1-5.333-1.856l-10.815-8.738a.658.658,0,0,1-.122-.924h0a.472.472,0,0,1,.057-.064.809.809,0,0,1,1.079-.064l10.817,8.738a6.972,6.972,0,0,0,8.129.372l5.606-3.688a.813.813,0,0,1,1.071.162.665.665,0,0,1-.111.933h0a.67.67,0,0,1-.065.046l-5.607,3.683a8.556,8.556,0,0,1-4.708,1.4",
    transform: "translate(-629.726 -311.896)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 2.627,
    height: 48.286,
    transform: "translate(893.482 180.393) rotate(-88.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.627,
    height: 33.817,
    transform: "translate(893.375 185.831) rotate(-88.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.626,
    height: 41.047,
    transform: "translate(893.268 191.267) rotate(-88.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.627,
    height: 48.286,
    transform: "translate(893.031 203.375) rotate(-88.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.627,
    height: 33.817,
    transform: "translate(892.923 208.813) rotate(-88.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.627,
    height: 48.286,
    transform: "translate(892.686 220.902) rotate(-88.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.627,
    height: 33.817,
    transform: "translate(892.579 226.339) rotate(-88.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(955.458 216.974)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.166 -8.259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.01,288.205l9.452,23.762,16.478-13.2L724.487,275Z",
    transform: "translate(-708.01 -275.004)",
    fill: "url(#d)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(937.977 214.321)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.576 -7.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M690.938,284.634l9.946,22.626,19.406-11.6-9.942-22.626Z",
    transform: "translate(-690.938 -273.037)",
    fill: "url(#f)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(972.861 286.448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.505,349.913l.234,1.918a.793.793,0,0,0,.694.7,12.387,12.387,0,0,0,2.57.039.678.678,0,0,0,.6-.75h0a.686.686,0,0,0-.028-.13,7,7,0,0,0-1.287-2.506h-2.132a.657.657,0,0,0-.653.66.435.435,0,0,0,.005.074",
    transform: "translate(-730.5 -349.179)",
    fill: "#0f0f0f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(954.594 264.698)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.851 -8.138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718.221,361.69l2.558-29.893-6.917-11.137L711.3,350.553Z",
    transform: "translate(-711.304 -320.66)",
    fill: "url(#h)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(953.81 284.895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.752,352.743h1.7a1.019,1.019,0,0,0,.812-.4c.53-.686,1.623-2.031,2.148-2.065.709-.046.615,2.462.615,2.462h.394l.5-3.118a1.849,1.849,0,0,0-.97-1.928,2.612,2.612,0,0,1-1.035,1.726c-.874.524-3.558,2.41-3.558,2.41a2.484,2.484,0,0,0-.688.02.448.448,0,0,0,.081.886",
    transform: "translate(-712.321 -347.696)",
    fill: "#0f0f0f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(963.476 264.824)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.003 -3.744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M734.1,356.4l2.318-27.078-14.462-4.349-2.318,27.078Z",
    transform: "translate(-719.634 -324.972)",
    fill: "url(#j)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(949.107 227.675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.751,309.22c-1.817-7.7,2.788-12.064,2.788-12.064-2.906-2.788-8.2-4.06-8.2-4.06s-5.052,3.7-4.454,6.584c.352,1.695,3.553,10.151,3.553,10.151a7.037,7.037,0,0,0,6.315-.613",
    transform: "translate(-707.834 -293.096)",
    fill: "#dbdcdd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.684,312.032c-.75-2.262-4.087-3.869-4.087-3.869a7.139,7.139,0,0,1-6.407.624,12.817,12.817,0,0,0-.21,4.964c.463,2.391,3.38,17.763,3.38,17.763,4.593.932,11.659-.937,11.659-.937-2.925-5.2-3.582-16.283-4.332-18.549",
    transform: "translate(-707.69 -292.373)",
    fill: "#d9dadc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(954.055 221.957)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.38 -2.428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M718.438,294.805l-1.8-9.482-5.4,3.23,1.8,9.482Z",
    transform: "translate(-711.238 -285.323)",
    fill: "url(#l)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(959.453 231.739)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.059 -0.006)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.736,
    height: 17.108,
    fill: "url(#n)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(951.626 216.293)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.424 -4.295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.144,294.437l5.375-9.563-8.174-6.737L706.97,287.7Z",
    transform: "translate(-706.97 -278.137)",
    fill: "url(#p)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(952.17 213.98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.051 -3.843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M706.891,281.782l4.657,11.674,10.689-5.42-4.657-11.674Z",
    transform: "translate(-706.891 -276.362)",
    fill: "url(#r)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(956.571 219.294)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.817 -1.648)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.4,289.228l1.742-3.1-2.222-2.6-1.742,3.1Z",
    transform: "translate(-714.176 -283.526)",
    fill: "url(#t)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(933.97 210.065)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.479 -2.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M691.025,277.952l3.645,8.307,6.854-4.368-3.645-8.307Z",
    transform: "translate(-691.025 -273.584)",
    fill: "url(#v)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936.219 212.626)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.408,
    height: 3.255,
    fill: "url(#x)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M150.088,267.791h1.035q1.163,0,1.289-.8l2.306-11.2-2.853,1.183.314-1.437,6.192-2.388-2.853,13.843a.68.68,0,0,0-.021.19q0,.613,1.014.613h1.014l-.127.782H149.94Z",
    transform: "translate(763.094 9.663)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstIcon);
export default __webpack_public_path__ + "static/media/first-icon.2f973993e0240e2cabccb956ceaf58ae.svg";
export { ForwardRef as ReactComponent };